import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  Box,
  Paper,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateEndorsementFormData,
  selectEndorsmentFormData,
} from 'src/features/rfqDataSlice';

const SuggestedDeductibleEditable = () => {
  const dispatch = useDispatch();

  const endorsementFormData = useSelector(selectEndorsmentFormData);

  const suggestedDeductibleData = endorsementFormData?.suggestedDeductible;

  // If not selected in Screen 1 → do not render
  if (!suggestedDeductibleData?.isSelected) return null;

  const handleChange = (value) => {
    dispatch(
      updateEndorsementFormData({
        ...endorsementFormData,
        suggestedDeductible: {
          ...suggestedDeductibleData, // preserve oldValue + isSelected
          newValue: value,
        },
      })
    );
  };

  return (
    <>
      {/* Section Header */}
      <Box sx={{ mb: 1,mt:1 }}>
        <Typography
          variant="h5"
          className="heading"
          sx={{
            background: 'rgb(9 84 174)',
            color: '#fff',
            py: 1,
            fontWeight: 'bold',
            pl: 2,
          }}
        >
            Deductible
        </Typography>
      </Box>

      {/* Content */}
     
        <Grid container spacing={2} alignItems="center" style={{display:'flex'}}>

          {/* FIELD NAME */}
          <Grid item   style={{width:'33%'}}>
            <Typography fontWeight="bold">
              Field
            </Typography>
            <Typography>
              Deductible
            </Typography>
          </Grid>

          {/* OLD VALUE */}
          <Grid item   style={{width:'31%'}}>
            <Typography fontWeight="bold" style={{color:'red'}}>
              Old Value
            </Typography>
            <Typography>
              {suggestedDeductibleData.oldValue || 'N/A'}
            </Typography>
          </Grid>

          {/* NEW VALUE */}
          <Grid item  style={{width:'35%'}}>
            <Typography fontWeight="bold" style={{color:'green'}}>
              New Value
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              size="small"
              value={suggestedDeductibleData.newValue || ''}
              onChange={(e) => handleChange(e.target.value)}
            />
          </Grid>

        </Grid>
     
    </>
  );
};

export default SuggestedDeductibleEditable;
